import actionTypes from '../constants/action-types';

const setPrices = (prices, extraPrice) => ({
  type: actionTypes.SET_PRICES,
  payload: {
    prices,
    extraPrice,
  },
});

export default setPrices;
